import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import {
    CalculationList,
    Colours,
    Formats,
    useForm,
} from '@ratehub/base-ui';


function PaymentCalculatorScenarioCalculations({
    lines,
    result,

    children,
    ...otherProps
}) {
    const form = useForm();
    const isNarrow = form.values.size.width < 780;

    return (
        <Container
            isHorizontal={isNarrow}
            {...otherProps}
        >
            <div className={classNames('sidebar', isNarrow ? 'rh-pb-1 rh-pt-0' : 'rh-pt-0_5 rh-pr-2')}>
                {children}
            </div>

            <If condition={!isNarrow}>
                <div className="divider" />
            </If>

            <CalculationList
                className={classNames('calculations', isNarrow ? 'rh-pt-0' : 'rh-pl-2')}
                variant="dashed"
                lines={lines}
                result={result}
            />
        </Container>
    );
}

PaymentCalculatorScenarioCalculations.propTypes = {
    lines: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.oneOfType([
                PropTypes.string, // Name of the registered form value
                PropTypes.number, // If the value isn't derived from anything
                PropTypes.func, // A possible equation to be added as a computed within the form
                PropTypes.object, // A field object used to render an input
            ]).isRequired,
            format: PropTypes.oneOf(Object.keys(Formats.number)),
            isSubLine: PropTypes.bool,
            label: PropTypes.node.isRequired,
            tooltipMessage: PropTypes.node,
        }),
    ).isRequired,
    result: PropTypes.shape({
        name: PropTypes.string.isRequired,
        label: PropTypes.node.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string, // Name of the registered form value
            PropTypes.number, // If the value isn't derived from anything
            PropTypes.func, // A possible equation to be added as a computed within the form
        ]).isRequired,
        operator: PropTypes.string,
    }),
    children: PropTypes.node.isRequired,
};

PaymentCalculatorScenarioCalculations.defaultProps = {
    result: undefined,
};

const Container = styled.div`
    display: flex;
    flex-direction: ${props => props.isHorizontal ? 'column' : 'row'};

    > .sidebar {
        flex: 1;
    }

    > .divider {
        height: ${props => props.isHorizontal ? '1px' : 'auto'};
        width: ${props => props.isHorizontal ? '100%' : '1px'};
        background-color: ${Colours.STONE_DARK};
    }

    > .calculations {
        flex: 2;
    }
`;

export default observer(PaymentCalculatorScenarioCalculations);
